import { render, staticRenderFns } from "./TeacherVisits.vue?vue&type=template&id=4b694eca&scoped=true&"
import script from "./TeacherVisits.vue?vue&type=script&lang=js&"
export * from "./TeacherVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b694eca",
  null
  
)

export default component.exports